export const environment = {
    production: false,
    // firebaseConfig: {
    //     apiKey: "AIzaSyCpZGNby1EBZ2Snve8CDlg0yIzuqChK7jk",
    //     authDomain: "project1-092025.firebaseapp.com",
    //     projectId: "project1-092025",
    //     storageBucket: "project1-092025.firebasestorage.app",
    //     messagingSenderId: "836888755561",
    //     appId: "1:836888755561:web:8fa949361be995b10591f8",
    //     measurementId: "G-P452GSX8NM"
    // }
    firebaseConfig: {
        apiKey: "AIzaSyD2AS0lMlxhKzRZSIDQ-kY2QUTqJrCaHwE",
        authDomain: "chalkbasket-79aa3.firebaseapp.com",
        projectId: "chalkbasket-79aa3",
        storageBucket: "chalkbasket-79aa3.firebasestorage.app",
        messagingSenderId: "657609608092",
        appId: "1:657609608092:web:d04200588efa9d64601659",
        measurementId: "G-GH14RJ1TXV"
    }

    // Temperory admin login
    // email:admin@chalkbacket.com
    // password:12345678
};
